import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { useRecordShellEnabled } from '../../../components/RecordShell/recordShellFlag';
import { CaptureDetailPage } from '../CaptureDetailPage';
import { PURSUIT_SECTION_COMPONENTS } from './pursuitSectionComponents';
/**
 * One `/capture/:id/<slug>` route element (GRW-15). Shell on: the section page.
 * Shell off: today's tabbed page at the index; nested slugs never get here
 * with the shell off, because PursuitRecordLayout redirects them to `?tab=`.
 */ export function PursuitSectionOutlet({ slug }) {
    const enabled = useRecordShellEnabled();
    const { id = '' } = useParams();
    if (!enabled) return slug === '' ? /*#__PURE__*/ _jsx(CaptureDetailPage, {}, id) : null;
    const Section = PURSUIT_SECTION_COMPONENTS[slug];
    return /*#__PURE__*/ _jsx(Section, {}, id);
}
